<!-- 院长端 -->
<template>
  <div>
    <div class="realTime_header">
      <div class="header_left">
        <a-breadcrumb separator=">">
          <a-breadcrumb-item style="color: #8c8c8c; cursor: pointer"
            ><span @click="handleBack(1)">实时监测</span></a-breadcrumb-item
          >
          <a-breadcrumb-item style="color: #595959; cursor: pointer"
            ><span>{{ this.$route.query.name }}</span></a-breadcrumb-item
          >
        </a-breadcrumb>
      </div>
      <div class="header_right">
        <a-icon class="iconHover" type="left-circle" />
        <span class="backHover" @click="handleBack(1)">返回</span>
        <span
          class="backHover"
          v-if="this.$route.path == '/dean/moreBed'"
          @click="handleBacks"
          >返回</span
        >
        <span
          class="backHover"
          v-if="this.$route.path == '/dean/record'"
          @click="handleBackworkAnalysis"
          >返回</span
        >
      </div>
    </div>
    <div class="main">
      <ToiletCom ref="toiletCom" />
    </div>
  </div>
</template>

<script>
import ToiletCom from '../../component/toilet/toiletCom.vue';

export default {
  components: { ToiletCom },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    handleBack() {
      console.log(this.$getCookie('userInfo').user.roleId);
      if (this.$getCookie('userInfo').user.roleId == 2) {
        this.$router.push('/dean/realTimeMonitor');
      } else if (this.$getCookie('userInfo').user.roleId == 3) {
        this.$router.replace('/protect/home');
      }
    },
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.realTime_header {
  width: 100%;
  // width: 1160px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  margin: 0 auto;
  position: absolute;
  top: 80px;
  left: 0;
  background: #ffffff;
  padding: 0 100px 0 130px;
  // box-shadow: 0px 1px 4px -2px rgba(0, 0, 0, 0.5);
  // padding: 0 130px 0 140px;

  .header_left {
    .ant-breadcrumb {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
  }
  .header_right {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1890ff;
    cursor: pointer;

    img {
      width: 21px;
      height: 21px;
      margin-right: 6px;
    }
  }
}
.main {
  margin-top: 70px;
}
</style>
